var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('DxFileUploader',{ref:"fileUploader",attrs:{"accept":"image/*","multiple":false,"upload-mode":"instantly","upload-url":_vm.fileUploadUrl,"upload-headers":_vm.headers,"name":"files"},on:{"uploaded":function($event){return _vm.onUploaded($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72585b98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/purchase/cmm/ImageUpload.vue
// module id = null
// module chunks = 